import { useNavigate, useSearch } from "@tanstack/react-router";
import { useSignInMutation } from "@/src/api/Auth";
import useAuth from "@/src/hooks/useAuth";
import AppForm from "@/src/components/Form";
import { LoginFormValuesType } from "@/src/components/Form/schemas.ts";
import { useToast } from "@/components/ui/use-toast";

function LoginPage() {
  const { onSignIn } = useAuth();
  const search = useSearch({
    strict: false,
  }) as { redirect?: string };
  const navigate = useNavigate();

  const { toast } = useToast();
  const { mutate: signIn } = useSignInMutation({
    onSuccess: (data) => {
      onSignIn({
        accessToken: data.accessToken,
        refreshToken: data.refreshToken,
        isLoggedIn: true,
      });
      setTimeout(() => {
        navigate({ to: search?.redirect || "/admin/tenant" });
      });
    },
    onError: () => toast({ title: "Błąd", description: "Wystąpił błąd", variant: "destructive" }),
  });

  function onSubmit(values: LoginFormValuesType) {
    signIn(values);
  }

  return (
    <div className="min-h-screen w-full flex items-center justify-center p-6 bg-gray-50">
      <div className="w-full max-w-md bg-white border border-gray-200 rounded-xl px-8 py-10 flex flex-col shadow-sm">
        <h1 className="text-2xl font-semibold">Logowanie</h1>
        <hr className="my-5" />
        <AppForm.Login onSubmit={onSubmit} />
      </div>
    </div>
  );
}

export default LoginPage;
